import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../../context/admin";
import Modal from "../../../common/Modal";
import AdminService from "../../../../services/admin.service";
import { useGlobal } from "../../../../context/global";

// used for traspax
export default function ConfirmDeletePayment() {
    const { setIsLoading } = useGlobal()
    const { confirmDeletePaymentId, setConfirmDeletePaymentId } = useAdmin()

    async function onDelete(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AdminService.deletePayment(confirmDeletePaymentId!)
            window.location.reload()
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal onSubmit={onDelete}>
            <h1>Confirm delete payment</h1>
            <p>Are you sure you want to delete this payment?</p>
            <div className="actions" 
            style={{ margin: '15px 0'}}
            >
                <button className="delete">Delete</button>
            </div>
            <div className="close" onClick={() => setConfirmDeletePaymentId(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}